var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-6 vstack gap-3" }, [
            _c("div", { staticClass: "vstack gap-10" }, [
              _c("div", [
                _c("h5", [_vm._v("Lista de permisos")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-sm text-muted mt-1" }, [
                  _vm._v("Permisos para el aceso al menu"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vstack gap-3 mt-4" },
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "w-100 row justify-content-between align-items-center border border-primary-hover text-heading p-3 rounded-2",
                        class:
                          _vm.selected == item.id
                            ? "bg-white border-primary"
                            : "",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-8 d-flex align-items-center" },
                          [
                            _c("i", {
                              staticClass: "text-lg me-3",
                              class: item.icon,
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "text-body text-sm font-semibold",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "ms-4" },
                                  [
                                    _c(
                                      "font",
                                      {
                                        staticStyle: {
                                          "vertical-align": "inherit",
                                        },
                                      },
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block text-sm text-muted",
                                      },
                                      [_vm._v(_vm._s(item.description))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between gap-6",
                            },
                            [
                              _c(
                                "div",
                                [
                                  index > 0 &&
                                  _vm.globalViewOption("PermissionOrder")
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "cursor-pointer text-sm text-muted text-danger-hover font-semibold",
                                          on: {
                                            click: function ($event) {
                                              return _vm.UP(index, index - 1)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-arrow-up-short me-2",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  index < _vm.items.length - 1 &&
                                  _vm.globalViewOption("PermissionOrder")
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "cursor-pointer text-sm text-muted text-danger-hover font-semibold",
                                          on: {
                                            click: function ($event) {
                                              return _vm.DOWN(index, index + 1)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-arrow-down-short me-2",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (
                                    !Array.isArray(item.items)
                                      ? true
                                      : item.items.length > 0
                                  )
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "cursor-pointer text-sm text-muted text-primary-hover font-semibold",
                                          class:
                                            _vm.selected == item.id
                                              ? "text-primary"
                                              : "",
                                          on: {
                                            click: function ($event) {
                                              return _vm.ONCHANGE(item.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi me-2",
                                            class:
                                              _vm.selected == item.id
                                                ? "bi-check-circle"
                                                : "bi-circle",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.globalViewOption("PermissionUpdate")
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "PermissionUpdate",
                                              params: { id: item.id },
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "cursor-pointer text-sm text-muted text-primary-hover font-semibold",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "bi bi-pencil-square me-2",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-6 vstack gap-3" },
            [
              _c("permission-item", {
                attrs: {
                  data: _vm.item_selected,
                  moveItem: _vm.moveItem,
                  loading: _vm.loading_two,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "col-12" }, [_vm._m(1)])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pt-6" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Permisos")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }